// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { type AuthUser } from '@/types';
import { useLocalStorage } from '@vueuse/core';
import { useSentry } from '@/composables/useSentry';

export default defineNuxtRouteMiddleware((middleware) => {
  const { isAuthenticated } = useSanctumAuth();
  const user: Ref<AuthUser | null> = useSanctumUser();
  const sentry = useSentry();

  if (!isAuthenticated.value) {
    useLocalStorage('redirect_to', middleware.path);
    sentry.addBreadcrumb(`Unauthorized access attempt`, 'auth', 'info', {
      timestamp: new Date().toISOString()
    });
    return navigateTo('/vdp/login');
  }

  sentry.setUser(user);

  if (user.value && user.value.roles) {
    const roles = user.value.roles;

    if (roles.includes('researcher') && !roles.includes('vendor')) {
      return abortNavigation();
    }
  } else {
    return navigateTo('vdp/login');
  }
});
